import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = `${process.env.REACT_APP_PRODUCTION_API_URL}backend/api/public-apis/`;


export const fetchHomeBanners = createAsyncThunk(
  'PublicAPIsService/fetchHomeBanners',
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${BASE_URL}home-banners`);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);
export const fetchOurTeam = createAsyncThunk(
  'PublicAPIsService/fetchOurTeam',
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${BASE_URL}our-team`);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);
export const fetchHomePageGallery = createAsyncThunk(
  'PublicAPIsService/fetchHomePageGallery',
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${BASE_URL}home-page-gallery`);
      return Array.isArray(res.data) ? res.data : [];
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);
export const fetchInitiatives = createAsyncThunk(
  'PublicAPIsService/fetchInitiatives',
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${BASE_URL}initiatives`);
      return Array.isArray(res.data) ? res.data : [];
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);
export const fetchWordsThatInspire = createAsyncThunk(
  'PublicAPIsService/fetchWordsThatInspire',
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${BASE_URL}words-that-inspire`);
      return Array.isArray(res.data) ? res.data : [];
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);
export const findAllActiveAboutUsMissionVision = createAsyncThunk(
  'PublicAPIsService/findAllActiveAboutUsMissionVision',
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${BASE_URL}about-us-mission-vision`);
      return Array.isArray(res.data) ? res.data : [];
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);
export const findAllEvents = createAsyncThunk(
  'PublicAPIsService/findAllEvents',
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${BASE_URL}all-events`);
      return Array.isArray(res.data) ? res.data : [];
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const findEventById = createAsyncThunk(
  'PublicAPIsService/findEventById',
  async (id, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${BASE_URL}event/${id}`);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);

export const findCoreInitiativeById = createAsyncThunk(
  'PublicAPIsService/findCoreInitiativeById',
  async (id, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${BASE_URL}core_initiative/${id}`);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);

export const fetchActiveCoreServices = createAsyncThunk(
  'PublicAPIsService/fetchActiveCoreServices',
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${BASE_URL}core-services`);
      return Array.isArray(res.data) ? res.data : [];
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);


export const fetchCoreServiceByTitle = createAsyncThunk(
  'PublicAPIsService/fetchCoreServiceByTitle',
  async (title, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${BASE_URL}core-service/${title}`
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);

export const createContactUs = createAsyncThunk(
  'PublicAPIsService/createContactUs',
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${BASE_URL}contact_us`, payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);

export const createVolunteer = createAsyncThunk(
  'PublicAPIsService/createVolunteer',
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${BASE_URL}volunteer`, payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);

export const subscribeNewsletter = createAsyncThunk(
  'PublicAPIsService/subscribeNewsletter',
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${BASE_URL}newsletter`,
        payload
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);

export const fetchActiveFaqs = createAsyncThunk(
  'PublicAPIsService/fetchActiveFaqs',
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${BASE_URL}faqs`,
        payload
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);


const PublicAPIsServiceSlice = createSlice({
  name: 'PublicAPIsService',
  initialState: {
    banners: [],
    bannersLoading: false,
    bannersError: null,

    team: [],
    teamLoading: false,
    teamError: null,

    gallery: [],              
    galleryLoading: false,    
    galleryError: null,

    initiatives: [],            
    initiativesLoading: false, 
    initiativesError: null,

    wordsThatInspire: [],
    wordsThatInspireLoading: false,
    wordsThatInspireError: null,

    aboutUsMissionVision: [],
    aboutUsMissionVisionLoading: false,
    aboutUsMissionVisionError: null,

    allEvents: [],
    allEventsLoading: false,
    allEventsError: null,

    eventDetail: null,
    eventDetailLoading: false,
    eventDetailError: null,

    coreInitiativeDetail: null,
    coreInitiativeDetailLoading: false,
    coreInitiativeDetailError: null,

    coreServices: [],
    coreServicesLoading: false,
    coreServicesError: null,


    coreServiceDetail: null,
    coreServiceDetailLoading: false,
    coreServiceDetailError: null,

    contactUsLoading: false,
    contactUsResponse: null,
    contactUsError: null,

    volunteerLoading: false,
    volunteerResponse: null,
    volunteerError: null,

    newsletterLoading: false,
    newsletterResponse: null,
    newsletterError: null,

    faqs: [],
    faqsLoading: false,
    faqsError: null,


  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(fetchHomeBanners.pending, (state) => {
        state.bannersLoading = true;
        state.bannersError = null;
      })
      .addCase(fetchHomeBanners.fulfilled, (state, action) => {
        state.bannersLoading = false;
        state.banners = action.payload;
      })
      .addCase(fetchHomeBanners.rejected, (state, action) => {
        state.bannersLoading = false;
        state.bannersError = action.payload;
      });
    builder
      .addCase(fetchOurTeam.pending, (state) => {
        state.teamLoading = true;
        state.teamError = null;
      })
      .addCase(fetchOurTeam.fulfilled, (state, action) => {
        state.teamLoading = false;
        state.team = action.payload;
      })
      .addCase(fetchOurTeam.rejected, (state, action) => {
        state.teamLoading = false;
        state.teamError = action.payload;
      });

    builder
      .addCase(fetchHomePageGallery.pending, (state) => {
        state.galleryLoading = true;
        state.galleryError = null;
      })
      .addCase(fetchHomePageGallery.fulfilled, (state, action) => {
        state.galleryLoading = false;
        state.gallery = action.payload;
      })
      .addCase(fetchHomePageGallery.rejected, (state, action) => {
        state.galleryLoading = false;
        state.galleryError = action.payload;
      });

    builder
      .addCase(fetchInitiatives.pending, (state) => {
        state.initiativesLoading = true;
        state.initiativesError = null;
      })
      .addCase(fetchInitiatives.fulfilled, (state, action) => {
        state.initiativesLoading = false;
        state.initiatives = action.payload;
      })
      .addCase(fetchInitiatives.rejected, (state, action) => {
        state.initiativesLoading = false;
        state.initiativesError = action.payload;
      });

    builder
      .addCase(fetchWordsThatInspire.pending, (state) => {
        state.wordsThatInspireLoading = true;
        state.wordsThatInspireError = null;
      })
      .addCase(fetchWordsThatInspire.fulfilled, (state, action) => {
        state.wordsThatInspireLoading = false;
        state.wordsThatInspire = action.payload;
      })
      .addCase(fetchWordsThatInspire.rejected, (state, action) => {
        state.wordsThatInspireLoading = false;
        state.wordsThatInspireError = action.payload;
      });

    builder
      .addCase(findAllActiveAboutUsMissionVision.pending, (state) => {
        state.aboutUsMissionVisionLoading = true;
        state.aboutUsMissionVisionError = null;
      })
      .addCase(findAllActiveAboutUsMissionVision.fulfilled, (state, action) => {
        state.aboutUsMissionVisionLoading = false;
        state.aboutUsMissionVision = action.payload;
      })
      .addCase(findAllActiveAboutUsMissionVision.rejected, (state, action) => {
        state.aboutUsMissionVisionLoading = false;
        state.aboutUsMissionVisionError = action.payload;
      });
    builder
      .addCase(findAllEvents.pending, (state) => {
        state.allEventsLoading = true;
        state.allEventsError = null;
      })
      .addCase(findAllEvents.fulfilled, (state, action) => {
        state.allEventsLoading = false;
        state.allEvents = action.payload;
      })
      .addCase(findAllEvents.rejected, (state, action) => {
        state.allEventsLoading = false;
        state.allEventsError = action.payload;
      });

    builder
      .addCase(findEventById.pending, (state) => {
        state.eventDetailLoading = true;
        state.eventDetailError = null;
      })
      .addCase(findEventById.fulfilled, (state, action) => {
        state.eventDetailLoading = false;
        state.eventDetail = action.payload;
      })
      .addCase(findEventById.rejected, (state, action) => {
        state.eventDetailLoading = false;
        state.eventDetailError = action.payload;
      });

    builder
      .addCase(fetchActiveCoreServices.pending, (state) => {
        state.coreServicesLoading = true;
        state.coreServicesError = null;
      })
      .addCase(fetchActiveCoreServices.fulfilled, (state, action) => {
        state.coreServicesLoading = false;
        state.coreServices = action.payload;
      })
      .addCase(fetchActiveCoreServices.rejected, (state, action) => {
        state.coreServicesLoading = false;
        state.coreServicesError = action.payload;
      });

    builder
      .addCase(fetchCoreServiceByTitle.pending, (state) => {
        state.coreServiceDetailLoading = true;
        state.coreServiceDetailError = null;
      })
      .addCase(fetchCoreServiceByTitle.fulfilled, (state, action) => {
        console.log("action.payload", action.payload)
        state.coreServiceDetailLoading = false;
        state.coreServiceDetail = action.payload || null;
      })
      .addCase(fetchCoreServiceByTitle.rejected, (state, action) => {
        state.coreServiceDetailLoading = false;
        state.coreServiceDetailError = action.payload;
      });

    builder
      .addCase(createContactUs.pending, (state) => {
        state.contactUsLoading = true;
        state.contactUsError = null;
        state.contactUsResponse = null;
      })
      .addCase(createContactUs.fulfilled, (state, action) => {
        state.contactUsLoading = false;
        state.contactUsResponse = action.payload;
      })
      .addCase(createContactUs.rejected, (state, action) => {
        state.contactUsLoading = false;
        state.contactUsError = action.payload;
      });

    builder
      .addCase(createVolunteer.pending, (state) => {
        state.volunteerLoading = true;
        state.volunteerError = null;
        state.volunteerResponse = null;
      })
      .addCase(createVolunteer.fulfilled, (state, action) => {
        state.volunteerLoading = false;
        state.volunteerResponse = action.payload;
      })
      .addCase(createVolunteer.rejected, (state, action) => {
        state.volunteerLoading = false;
        state.volunteerError = action.payload;
      });
    builder
      .addCase(subscribeNewsletter.pending, (state) => {
        state.newsletterLoading = true;
        state.newsletterError = null;
        state.newsletterResponse = null;
      })
      .addCase(subscribeNewsletter.fulfilled, (state, action) => {
        state.newsletterLoading = false;
        state.newsletterResponse = action.payload;
      })
      .addCase(subscribeNewsletter.rejected, (state, action) => {
        state.newsletterLoading = false;
        state.newsletterError = action.payload;
      });

    builder
      .addCase(fetchActiveFaqs.pending, (state) => {
        state.faqsLoading = true;
        state.faqsError = null;
      })
      .addCase(fetchActiveFaqs.fulfilled, (state, action) => {
        state.faqsLoading = false;
        state.faqs = action.payload;
      })
      .addCase(fetchActiveFaqs.rejected, (state, action) => {
        state.faqsLoading = false;
        state.faqsError = action.payload;
      });

    builder
      .addCase(findCoreInitiativeById.pending, (state) => {
        state.coreInitiativeDetailLoading = true;
        state.coreInitiativeDetailError = null;
        state.coreInitiativeDetail = null;
      })

      .addCase(findCoreInitiativeById.fulfilled, (state, action) => {
        state.coreInitiativeDetailLoading = false;
        state.coreInitiativeDetail = action.payload;
      })

      .addCase(findCoreInitiativeById.rejected, (state, action) => {
        state.coreInitiativeDetailLoading = false;
        state.coreInitiativeDetailError = action.payload;
      });

  },
});

export default PublicAPIsServiceSlice.reducer;
